import {createApp} from 'vue'
import App from './App.vue'
import "./assets/style.css";
import router from "@/plugins/router";
import {createPinia} from "pinia";
import vuetify from "@/plugins/vuetify";
import i18n from "@/i18n";

//loadFonts()

const app = createApp(App)
app.use(router)
app.use(i18n)

const pinia = createPinia()
pinia.use(() => {
    return {
        devtools: false,
    }
})
app.use(pinia)

app.use(vuetify)

app.mount('#app')
